import { StarIcon, StarFilledIcon } from '@radix-ui/react-icons';
import { type BaseSyntheticEvent } from 'react';

import useFavoritesStore from '@/store/use-favorites-store';

interface FavoriteButtonProps {
  symbol: string;
  size?: number;
}

export default function FavoriteButton({
  symbol,
  size = 14,
}: FavoriteButtonProps) {
  const isFavorite = useFavoritesStore((state) => state.getIsFavorite(symbol));

  const handleFavorite = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    useFavoritesStore.getState().toggleFavorite(symbol);
  };

  return (
    <div className="cursor-pointer" onClick={handleFavorite}>
      {isFavorite ? (
        <StarFilledIcon className="text-primary" width={size} height={size} />
      ) : (
        <StarIcon className="text-vestgrey-200" width={size} height={size} />
      )}
    </div>
  );
}
